import axios from '@/resources/libs/axios'

export default {
    list(data) {
        return axios.get(`/vhe/auxiliaries/document-types/list/all`, { params: data })
    },
    search(data) {
        return axios.get(`/vhe/auxiliaries/document-types/list`,{ params: data })
    },
    find(data) {
        return axios.get(`/vhe/auxiliaries/document-types/find/${data.id}`,{ params: data })
    },
    create(data) {
        return axios.post(`/vhe/auxiliaries/document-types/create`,  data)
    },
    update(data) {
        return axios.post(`/vhe/auxiliaries/document-types/update`,  data)
    },
    delete(id) {
        return axios.delete(`/vhe/auxiliaries/document-types/delete/${id}`)
    },
}